import React from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";


const MiscBillPassingMenu = () => {
  useAuthRedirect();
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Branch Bill Passing Menu
          </h2>
          <Time />
        </section>

     <div className="container">
      <table className="transaction-table ">
        <thead>
          <tr>
            <th className="table-header">Branch Bill Passing Menu</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><Link to="/inventory/miscBillPassingGRNView">GRN (Misc)</Link></td>
          </tr>
          <tr>
          {/* <td><Link to="/inventory/miscBillPassingGrnRejectionView">Rejected GRN (Misc)</Link></td> */}
          </tr>
        </tbody>
      </table>
      </div>
    </div>
    </div>
  );
};

export default MiscBillPassingMenu;
